import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import propertySlice from "./features/propertySlice";
import tokenSlice from "./features/tokenSlice";
import cartSlice from "./features/cartSlice";
import { combineReducers } from "redux";
import filterSlice from "./features/filterSlice";
import psaFilterSlice from "./features/psaFilterSlice";
import giFilterSlice from "./features/giFilterSlice";
import vafpFilterSlice from "./features/vafpFilterSlice";
import eventSlice from "./features/eventSlice";
import authSlice from "./features/authSlice";
import bulkSlice from "./features/bulkUploadSlice";
import swapDataSlice from "./features/swapDataSlice";
import summerCampSlice from "./features/summerCampSlice";
import userDataSlice from "./features/userDataSlice";
import oneFilterSlice from "./features/oneFilterSlice";
import vivaCartSlice from "./features/vivaCartSlice";
import filteredEventSlice from "./features/filteredEvents";

import cartMiddleware from "@/app/middleware/reduxMiddleware";
import scheduleFilterSlice from "./features/scheduleFilterSlice";
import leaderboardFilterSlice from "./features/leaderBoardSlice";
const rootReducer = combineReducers({
  properties: propertySlice,
  token: tokenSlice,
  cart: cartSlice,
  filter: filterSlice,
  scheduleFilter: scheduleFilterSlice,
  leaderboardFilter: leaderboardFilterSlice,
  events: eventSlice,
  auth: authSlice,
  bulkUploadData: bulkSlice,
  swapData: swapDataSlice,
  summerCamp: summerCampSlice,
  user: userDataSlice,
  oneFilter: oneFilterSlice,
  psaFilter: psaFilterSlice,
  giFilter: giFilterSlice,
  vafpFilter: vafpFilterSlice,
  vivaCart: vivaCartSlice,
  filteredEvent: filteredEventSlice,
});

const persistConfig = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(cartMiddleware),
});

const persistor = persistStore(store);

export { store, persistor };
